let fauxSuppliers = [];
fauxSuppliers.push({
	IsSelected: false,
	Text: 'Weet niet/niet van toepassing',
	Value: ''
});
fauxSuppliers.push({
	IsSelected: false,
	Text: 'Verhuizing',
	Value: 'verhuizen'
});
const seperator = '-----------------';
fauxSuppliers.push({
	IsSelected: false,
	Text: seperator,
	Value: null
});
fauxSuppliers.push({
	IsSelected: false,
	Text: 'Essent',
	Value: 'essent'
});
fauxSuppliers.push({
	IsSelected: false,
	Text: 'Eneco',
	Value: 'eneco'
});
fauxSuppliers.push({
	IsSelected: false,
	Text: 'Vattenfall',
	Value: 'vattenfall'
});
fauxSuppliers.push({
	IsSelected: false,
	Text: seperator,
	Value: null
});
export default {
	fauxSuppliers: fauxSuppliers
};
